/**
 * PolicySlice Core Reducers
 * 
 * Core CRUD operations for the policy entity.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { PolicyView } from '../../types/policyTypes';
import { PolicySliceState } from '../state';
import { createDefaultPolicy } from '../../createDefaultPolicy';

// =============================================================================
// CORE REDUCERS
// =============================================================================

/**
 * Initialize a new policy with default values
 */
export const initializePolicy: CaseReducer<PolicySliceState> = (state) => {
  state.currentPolicy = createDefaultPolicy();
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
};

/**
 * Update the current policy with partial data
 */
export const updatePolicy: CaseReducer<PolicySliceState, PayloadAction<Partial<PolicyView>>> = (
  state,
  action
) => {
  if (state.currentPolicy) {
    state.currentPolicy = { ...state.currentPolicy, ...action.payload };
    state.isEdited = true;
    // Add all updated fields to editedFields
    Object.keys(action.payload).forEach((field) => {
      if (!state.editedFields.includes(field)) {
        state.editedFields.push(field);
      }
    });
  }
};

/**
 * Clear the current policy
 */
export const clearPolicy: CaseReducer<PolicySliceState> = (state) => {
  state.currentPolicy = null;
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
};

/**
 * Set the selected company for filtering policies
 */
export const setSelectedCompany: CaseReducer<PolicySliceState, PayloadAction<string>> = (
  state,
  action
) => {
  state.selectedCompany = action.payload;
};

/**
 * Clear all policies
 */
export const clearPolicies: CaseReducer<PolicySliceState> = (state) => {
  state.policies = [];
};
